import { render } from "./MessageTempate.vue?vue&type=template&id=4f6f5880&scoped=true&lang=pug"
import script from "./MessageTempate.vue?vue&type=script&lang=js"
export * from "./MessageTempate.vue?vue&type=script&lang=js"

import "./MessageTempate.vue?vue&type=style&index=0&id=4f6f5880&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6f5880"]])

export default __exports__